import { miniNav as controller } from '@kk/utils';
import toast from '@kk/toast';

export function miniNav(url, opt) {
    window.isJsSDKReady ? controller(url, opt) : toast.show('资源加载失败，请退出重试');
}
